import { combineReducers } from 'redux';

import { newsReducer } from './news';
import { commentsReducer } from './comments';

export const postCardReducer = combineReducers({
  news: newsReducer,
  comments: commentsReducer,
});
